import React from 'react';
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import Analytics from "../../../analytics";
import {changeStateToQuote} from "../../../actions/actionFunctions";
import {toggleShowAdvancedQuoting} from "../../../actions/advancedQuotingFunctions";
import {toggleShowAllQuotesCartItemsList, toggleShowMobileQuotes} from "../../../actions/shoppingCartFunctions";

const AdvancedQuotingSwitcher = (props) => {

  const {showAdvancedQuoting, changeStateToQuote, toggleShowAdvancedQuoting, toggleShowMobileQuotes} = props;

  if (!document.kvConfig.isBackend) {
    return null
  }

  const handleButtonClick = () => {
    Analytics.sendClickEvent(`advanced-quoting-click-${!showAdvancedQuoting ? "on" : "off"}`);
    changeStateToQuote();
    toggleShowMobileQuotes(false);
    toggleShowAdvancedQuoting(!showAdvancedQuoting);
  };

  return (
    <div className="ui-radio-block">
      <span className="ui-radio-label"><FormattedMessage id="header.advanceQuotingRadioButton"/></span>
      <button className={"ui-radio ui-radio--small" + (showAdvancedQuoting ? " ui-radio--checked" : "")}
              onClick={handleButtonClick}>
        <span className="ui-radio-circle"/>
        <span className="ui-radio-text ui-radio-text--yes"><FormattedMessage id="radioButton.on"/></span>
        <span className="ui-radio-text ui-radio-text--no"><FormattedMessage id="radioButton.off"/></span>
      </button>
    </div>
  )
};

const mapStateToProps = (store) => {
  const {showAdvancedQuoting} = store.advancedQuotingState;
  return {
    showAdvancedQuoting,
  };
};

const mapDispatchToProps = {
  changeStateToQuote,
  toggleShowAdvancedQuoting,
  toggleShowAllQuotesCartItemsList,
  toggleShowMobileQuotes
};

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedQuotingSwitcher);
